import { type SyntheticEvent, useState } from 'react';

export const useExpandableCard = (defaultExpanded = true) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const expand = () => setExpanded(true);
  const accordionProps = {
    expanded,
    onChange: (_event: SyntheticEvent, value: boolean) => setExpanded(value),
  };
  return { expanded, expand, accordionProps };
};
